import { Shield, Phone, Award } from "lucide-react";

export const WhyChooseUs = () => {
  return (
    <section className="py-12 px-4 bg-gradient-to-b from-white to-purple-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12 animate-fade-up">
          <h2 className="text-3xl md:text-4xl font-bold text-primary-dark mb-6">
            Why Choose Our Auto Insurance
          </h2>
          <p className="text-lg text-neutral max-w-2xl mx-auto">
            Experience superior coverage and exceptional service with our comprehensive auto insurance solutions.
          </p>
        </div>

        <div className="grid sm:grid-cols-3 gap-8">
          <div className="bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition-all duration-200 animate-scale-in" style={{ animationDelay: "0.2s" }}>
            <div className="p-3 bg-[#F1F0FB] rounded-full w-fit mb-4">
              <Shield className="h-6 w-6 text-primary" />
            </div>
            <h3 className="text-xl font-semibold text-primary-dark mb-2">Trusted Protection</h3>
            <p className="text-neutral">Backed by top-rated insurance carriers with proven track records.</p>
          </div>

          <div className="bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition-all duration-200 animate-scale-in" style={{ animationDelay: "0.4s" }}>
            <div className="p-3 bg-[#F1F0FB] rounded-full w-fit mb-4">
              <Phone className="h-6 w-6 text-primary" />
            </div>
            <h3 className="text-xl font-semibold text-primary-dark mb-2">24/7 Support</h3>
            <p className="text-neutral">Round-the-clock assistance and claims support whenever you need it.</p>
          </div>

          <div className="bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition-all duration-200 animate-scale-in" style={{ animationDelay: "0.6s" }}>
            <div className="p-3 bg-[#F1F0FB] rounded-full w-fit mb-4">
              <Award className="h-6 w-6 text-primary" />
            </div>
            <h3 className="text-xl font-semibold text-primary-dark mb-2">Competitive Rates</h3>
            <p className="text-neutral">Affordable premiums with flexible payment options to fit your budget.</p>
          </div>
        </div>
      </div>
    </section>
  );
};